import { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";

const CustomPopover = ({ name, children, width, confirmModal }) => {
  return (
    <Popover className="relative z-50">
      <Popover.Button as={Fragment}>{name}</Popover.Button>
      <Transition
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <div className={`${confirmModal && "fixed h-full w-full top-0 left-0 bg-zinc-100/50"}`}>
          <Popover.Panel
            className={`${
              confirmModal
                ? "fixed  top-1/2 left-1/2 w-96 transform -translate-x-1/2 -translate-y-1/2 z-10"
                : "absolute z-10  origin-top-right  -right-20 md:right-0 mt-2"
            } ${
              width ? width : "w-auto"
            } overflow-visible bg-transparent focus:outline-none`}
          >
            <div>{children}</div>
          </Popover.Panel>
        </div>
      </Transition>
    </Popover>
  );
};

export default CustomPopover;
